import { render, staticRenderFns } from "./PatientGeneral.vue?vue&type=template&id=5722249c&"
import script from "./PatientGeneral.vue?vue&type=script&lang=ts&"
export * from "./PatientGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports